export const loginGoogle = () => {
  console.log('guugo');
};
